import { RatingValue } from "../../Components/Utils/Rating/Rating"
import { CurateResource } from "../Curate/CurateResource"
import type { McpDebugTurn } from "./AnalyseChatData"
import { MessageType } from "./MessageType"

export type Message = {
    id: string,
    content: string,
    chatId: string,
    date: Date,
    type: MessageType,
    format: AnalyseFormat,
    rating?: RatingValue,
    feedback?: string
    debugTurns?: McpDebugTurn[]
    /** Set when the stream failed; the bubble stays so the user can retry. */
    error?: string
    /** True when the user stopped generation; partial content is kept. */
    cancelled?: boolean
}

export interface ResourceMessage extends Message {
    resources: CurateResource[]
}

export enum AnalyseFormat {
    DiagnosticSummary = 0,
    AreasOfStrength = 1,
    AreasForImprovement = 2,
    StaffDevelopment = 4,
    Text = 6
}